import { type ViewFieldListResponse } from '@air/api/types';

/**
 * Filter out internal analytics fields from viewFields:
 * - views
 * - downloads
 */
export const filterOutInternalAnalyticsFields = (viewFields: ViewFieldListResponse): ViewFieldListResponse => ({
  ...viewFields,
  data: viewFields.data.filter((field) => field.name !== 'views' && field.name !== 'downloads'),
});
